// Issue-type driven problem detail cards.
export const ISSUE_TYPES = [
  {
    id: "iptal",
    title: "Abonelik iptal etmek istiyorum",
    subtitle:
      "İnternet, telefon, TV, dijital üyelik veya hizmet aboneliğinizi sonlandırın.",
    icon: "unplug",
  },
  {
    id: "fatura",
    title: "Fatura / cayma bedeline itiraz etmek istiyorum",
    subtitle: "Haksız fatura, taahhüt ve cayma bedeli sorunları için itiraz.",
    icon: "receipt",
  },
  {
    id: "iade",
    title: "İade / değişim sorunum var",
    subtitle: "E-ticaret siparişinde iade, değişim veya para iadesi problemi.",
    icon: "package-x",
  },
  {
    id: "hakem",
    title: "Tüketici Hakem Heyeti dosyası hazırlamak istiyorum",
    subtitle: "Başvuru metni, gerekli belgeler ve itiraz dilekçesi.",
    icon: "gavel",
  },
];

const SUB_ISSUES = {
  iptal: [
    "İptal edemiyorum",
    "İptal ettim ama hâlâ para kesiliyor",
    "Cayma bedeli çıkardılar",
    "Modem / dekoder / cihaz iadesi istiyorlar",
    "Müşteri hizmetlerine ulaşamıyorum",
    "Ne yapacağımı bilmiyorum",
  ],
  fatura: [
    "Haksız fatura kesildi",
    "Cayma bedeli çıkardılar",
    "Taahhüt sonrası ekstra ücret geldi",
    "Kullanmadığım hizmet için ücret kesildi",
    "İptal sonrası fatura devam ediyor",
  ],
  iade: [
    "Siparişimi iptal edemiyorum",
    "Ürünü iade etmek istiyorum",
    "İadem reddedildi",
    "Para iadem yatmadı",
    "Yanlış / eksik ürün geldi",
    "Ürün ayıplı çıktı",
    "Satıcı cevap vermiyor",
  ],
  hakem: [
    "Başvuru metni hazırlamak istiyorum",
    "Belgelerim yeterli mi kontrol etmek istiyorum",
    "İtiraz dilekçesi oluşturmak istiyorum",
  ],
};

export function getProblemDetails(issueId) {
  return SUB_ISSUES[issueId] || [];
}

const DISPLAY_LABELS = {
  iptal: {
    "İptal edemiyorum": "İptal talebim işleme alınmadı",
    "İptal ettim ama hâlâ para kesiliyor": "İptal etmeme rağmen fatura geliyor",
    "Modem / dekoder / cihaz iadesi istiyorlar": "Cihaz veya modem iadesi sorunum var",
    "Ne yapacağımı bilmiyorum": "Başka bir sorun yaşıyorum",
  },
};

// Kullanıcı dostu iptal seçenekleri yalnızca bir sunum katmanıdır. `value`
// alanları mevcut backend problem değerlerinden seçilir; API'ye yeni bir değer
// gönderilmez. Aynı genel backend değerine bağlanan seçenekler, UI'da ayrı bir
// `id` ile izlenir.
export const CANCELLATION_PROBLEM_OPTIONS = [
  {
    id: "first-request",
    label: "İlk kez iptal başvurusu yapacağım",
    value: "Ne yapacağımı bilmiyorum",
  },
  {
    id: "not-cancelled",
    label: "Başvurdum ama iptal edilmedi",
    value: "İptal edemiyorum",
  },
  {
    id: "termination-fee",
    label: "Cayma bedeli çıkarılıyor",
    value: "Cayma bedeli çıkardılar",
  },
  {
    id: "billing-continues",
    label: "İptal ettim ama fatura gelmeye devam ediyor",
    value: "İptal ettim ama hâlâ para kesiliyor",
  },
  {
    id: "device-return",
    label: "Modem veya cihaz iadesi sorunum var",
    value: "Modem / dekoder / cihaz iadesi istiyorlar",
  },
  {
    id: "commitment-ended",
    label: "Taahhüdüm bitti ama abonelik sürüyor",
    value: "İptal edemiyorum",
  },
  {
    id: "unreachable",
    label: "Kuruma ulaşamıyorum",
    value: "Müşteri hizmetlerine ulaşamıyorum",
  },
  {
    id: "other",
    label: "Başka bir sorun yaşıyorum",
    value: "Ne yapacağımı bilmiyorum",
  },
];

export function getProblemOptions(issueId) {
  if (issueId === "iptal") return CANCELLATION_PROBLEM_OPTIONS;
  return getProblemDetails(issueId).map((value) => ({
    id: value,
    label: getProblemDisplayLabel(issueId, value),
    value,
  }));
}

export const CANCELLATION_ADDITIONAL_DETAILS = [
  { key: "request-not-processed", label: "İptal talebim işleme alınmadı", generatedSentence: "İptal talebim işleme alınmadı.", backendProblemValue: null, applicableServiceTypes: ["all"], requiresFreeText: false },
  { key: "still-active", label: "İptal edildi denildi ama abonelik açık", generatedSentence: "İptal edildiği söylenmesine rağmen aboneliğim hâlâ açık görünüyor.", backendProblemValue: null, applicableServiceTypes: ["all"], requiresFreeText: false },
  { key: "billing-after-cancellation", label: "İptal sonrası fatura geliyor", generatedSentence: "İptal talebime rağmen fatura gelmeye devam ediyor.", backendProblemValue: null, applicableServiceTypes: ["all"], requiresFreeText: false },
  { key: "termination-fee-added", label: "Cayma bedeli çıkarıldı", generatedSentence: "İptal sürecinde cayma bedeli çıkarıldı.", backendProblemValue: null, applicableServiceTypes: ["all"], requiresFreeText: false },
  { key: "charged-after-commitment", label: "Taahhüdüm bitti ama ücret alınıyor", generatedSentence: "Taahhüdüm sona ermesine rağmen ücret alınmaya devam ediyor.", backendProblemValue: null, applicableServiceTypes: ["all"], requiresFreeText: false },
  { key: "support-unreachable", label: "Müşteri hizmetlerine ulaşamıyorum", generatedSentence: "Müşteri hizmetlerine ulaşamıyorum.", backendProblemValue: null, applicableServiceTypes: ["all"], requiresFreeText: false },
  { key: "online-screen-broken", label: "Online iptal ekranı çalışmıyor", generatedSentence: "Online iptal ekranı çalışmıyor.", backendProblemValue: null, applicableServiceTypes: ["all"], requiresFreeText: false },
  { key: "no-reference", label: "Başvuru numarası verilmedi", generatedSentence: "İptal başvurum için kayıt veya başvuru numarası verilmedi.", backendProblemValue: null, applicableServiceTypes: ["all"], requiresFreeText: false },
  { key: "device-return-unknown", label: "Modem veya cihazı nasıl iade edeceğimi bilmiyorum", generatedSentence: "Modem veya cihazı nasıl iade edeceğimi bilmiyorum.", backendProblemValue: null, applicableServiceTypes: ["all"], requiresFreeText: false },
  { key: "device-returned-debt", label: "Cihazı iade ettim ama borç görünüyor", generatedSentence: "Cihazı iade etmeme rağmen borç görünüyor.", backendProblemValue: null, applicableServiceTypes: ["all"], requiresFreeText: false },
  { key: "service-interruption", label: "Hizmet alamıyorum veya sürekli kesinti yaşıyorum", generatedSentence: "Hizmet alamıyorum veya sürekli kesinti yaşıyorum.", backendProblemValue: null, applicableServiceTypes: ["all"], requiresFreeText: false },
  { key: "moving", label: "Taşındığım için iptal ediyorum", generatedSentence: "Taşındığım için aboneliğimi iptal ediyorum.", backendProblemValue: null, applicableServiceTypes: ["all"], requiresFreeText: false },
  { key: "deceased-relative", label: "Vefat eden yakınımın aboneliğini kapatıyorum", generatedSentence: "Vefat eden yakınımın aboneliğini kapatmak istiyorum.", backendProblemValue: null, applicableServiceTypes: ["all"], requiresFreeText: false },
  { key: "other", label: "Başka bir durum", generatedSentence: "", backendProblemValue: null, applicableServiceTypes: ["all"], requiresFreeText: true },
];

export const CANCELLATION_ADDITIONAL_INCOMPATIBLE_BY_PROBLEM = Object.freeze({
  "first-request": Object.freeze([
    "request-not-processed",
    "still-active",
    "billing-after-cancellation",
  ]),
});

export function isCancellationAdditionalDetailCompatible(problemChoice, detailKey) {
  return !(CANCELLATION_ADDITIONAL_INCOMPATIBLE_BY_PROBLEM[problemChoice] || [])
    .includes(detailKey);
}

export function getCompatibleCancellationAdditionalDetails(problemChoice) {
  return CANCELLATION_ADDITIONAL_DETAILS.filter((item) => (
    isCancellationAdditionalDetailCompatible(problemChoice, item.key)
  ));
}

export function filterCompatibleCancellationAdditionalKeys(problemChoice, selectedKeys = []) {
  return selectedKeys.filter((key) => (
    isCancellationAdditionalDetailCompatible(problemChoice, key)
  ));
}

function sentenceAfterConnector(value) {
  const sentence = String(value || "").trim();
  return sentence ? sentence.charAt(0).toLocaleLowerCase("tr-TR") + sentence.slice(1) : "";
}

export function buildCancellationAdditionalDescription(selectedKeys = [], freeText = "", problemChoice = null) {
  const compatibleKeys = filterCompatibleCancellationAdditionalKeys(problemChoice, selectedKeys);
  const sentences = compatibleKeys
    .map((key) => CANCELLATION_ADDITIONAL_DETAILS.find((item) => item.key === key))
    .filter((item) => item && !item.requiresFreeText && item.generatedSentence)
    .map((item) => item.generatedSentence);
  const custom = String(freeText || "").trim();
  if (custom) sentences.push(/[.!?]$/.test(custom) ? custom : `${custom}.`);
  return sentences.map((sentence, index) => (
    index === 0 ? sentence : `Ayrıca ${sentenceAfterConnector(sentence)}`
  )).join(" ");
}

export function getProblemDisplayLabel(issueId, value) {
  return DISPLAY_LABELS[issueId]?.[value] || value;
}

export const DESCRIPTION_PLACEHOLDERS = [
  "İptal ettim ama hâlâ fatura geliyor.",
  "İadem reddedildi, ürün ayıplıydı.",
  "Cayma bedeli çıkardılar.",
  "Müşteri hizmetlerine ulaşamıyorum.",
];
